import enviro from 'enviro';
const GOOGLE_CHAT_PROD_APP_ID = 3280929;
const GOOGLE_CHAT_QA_APP_ID = 9108910;
const isGoogleChatAppId = appId => {
  const googleChatAppId = enviro.isProd() ? GOOGLE_CHAT_PROD_APP_ID : GOOGLE_CHAT_QA_APP_ID;
  return Number(appId) === googleChatAppId;
};
export default {
  isGoogleChatAppId
};